// Generated from public/locales/en by studio/scripts/sync-library.mjs. Do not edit by hand.
export const CONTENT_AREAS = {
  "core_ui": {
    "label": "Core UI",
    "description": "All remaining patient-facing interface, help, accessibility, legal and support text.",
    "namespaces": [
      "a11y",
      "about",
      "auto",
      "common",
      "compare",
      "errors",
      "feedback",
      "find",
      "home",
      "install",
      "journeyPreview",
      "landing",
      "library",
      "more",
      "myCare",
      "myNotes",
      "myQuestions",
      "nav",
      "offlineLibrary",
      "privacy",
      "quickFacts",
      "requestHospitalUniforms",
      "roleCard",
      "settings",
      "sidebar",
      "support",
      "terms",
      "tools",
      "translationInfo",
      "ui",
      "uniformPicker"
    ]
  },
  "know_your_team": {
    "label": "Know Your Team",
    "description": "Role names, patient guides and role-detail explanations.",
    "namespaces": [
      "jobDetail",
      "patientGuides",
      "roleDetail",
      "roles"
    ]
  },
  "know_your_hospital": {
    "label": "Know Your Hospital",
    "description": "The illustrated hospital information page and its fixed section titles.",
    "namespaces": [
      "knowYourHospital"
    ]
  },
  "hospital_journeys": {
    "label": "Hospital Journeys",
    "description": "Journey stages, useful links, questions and supporting interface text.",
    "namespaces": [
      "hospitalJourney",
      "journeyInfo"
    ]
  },
  "what_you_might_hear": {
    "label": "What You Might Hear",
    "description": "Clinical phrases, explanations, patient context and suggested questions.",
    "namespaces": [
      "whatYouMightHear"
    ]
  }
};
export const TRANSLATION_NAMESPACE_COUNT = 39;
